import { notify } from 'utils'

export default {
  methods: {
    handleServerErrorsCallback (error) {
      if (error.response && error.response.status === 500) {
        notify.error('We encountered a server error, please try again later.')
      } else if (error.response) {
        notify.error('Something went wrong, please try again later.')
      } else {
        return Promise.reject(error)
      }
    }
  }
}
